var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-iconstack',_vm._b({},'b-iconstack',_vm.$attrs,false),[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"100%","height":"100%","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":_vm.path,"name":_vm.iconame}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }